export default {"src":"/_next/static/media/minus.a200418e.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};